// client/src/modules/workshop/nav.ts
import type { NavItem } from '../types';

/**
 * Workshop module nav (P19).
 *
 * Per-tool entitlement is enforced by useWorkshopToolAccess at render time
 * (see hooks/workshop). The requireManagerOrAdmin flag is the coarse
 * floor for module-aware nav; the per-tool floor + grant resolver narrows it.
 */
export const navItems: NavItem[] = [
  { label: 'Dashboard', path: '/workshop' },
  {
    label: 'Outreach',
    path: '/workshop/outreach',
    requireManagerOrAdmin: true,
    children: [
      { label: 'Overview', path: '/workshop/outreach' },
      { label: 'Letters', path: '/workshop/outreach/letters' },
      { label: 'Contacts', path: '/workshop/outreach/contacts' },
      { label: 'Sender profiles', path: '/workshop/outreach/settings' },
    ],
  },
  {
    label: 'Documents',
    path: '/workshop/docfill',
    requireManagerOrAdmin: true,
  },
  // Each tool adds its own nav item as it ships.
];
